module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/events/event-edit/event-edit.component.css
// module id = ./src/app/components/events/event-edit/event-edit.component.css
// module chunks = main